<template>
    <!-- *********************************************
	*              Origin Account Block              *
	********************************************** -->
	<divider-generic dividerSize="medium" icon="account-balance" :title="t('transfers.kwik.accountManagement.step2.originAccountTitle')" :applyBorder="false"/>
	<text-block-generic
	:mask="ACCOUNTS_NIB_IBAN"
	:params="{
		label: t('transfers.kwik.accountManagement.step3.account'),
		content: formData.accountDisplayInfo
	}"/>
    <!-- *********************************************
	*                     Key Block                  *
	********************************************** -->
    <divider-generic dividerSize="medium" icon="key" :title="t('transfers.kwik.accountManagement.step3.keyTitle')"/>
    <text-block-generic
	:params="{
		label: t('transfers.kwik.accountManagement.step3.keyType'),
		content: t(`transfers.kwik.accountManagement.step3.keyType${formData.aliasType}`)
	}"/>
    <!-- Phone Block -->
    <text-block-generic
    v-if="formData.aliasType === 'PN'"
    :params="{
        label: t('transfers.kwik.accountManagement.step3.phoneLabel'),
        content: formData.alias
    }"/>
    <!-- Email Block -->
    <text-block-generic
    v-if="formData.aliasType === 'EM'"
    :params="{
        label: t('transfers.kwik.accountManagement.step3.emailLabel'),
        content: formData.alias
    }"/>
    <!-- Nickname Block -->
    <text-block-generic
    v-if="formData.aliasType === 'NN'"
    :params="{
        label: t('transfers.kwik.accountManagement.step3.nicknameLabel'),
        content: formData.alias
    }"/>
    <!-- Strong Factor Block -->
    <text-block-generic
    v-if="formData.aliasType === 'NN'"
    :params="{
        label: t('transfers.kwik.accountManagement.step3.strongFactorLabel'),
        content: formData.authMethodType === 'PN' ? t('transfers.kwik.accountManagement.step3.phoneLabel') : t('transfers.kwik.accountManagement.step3.emailLabel')
    }"/>
    <text-block-generic
    v-if="formData.aliasType === 'NN'"
    :params="{
        label: formData.authMethodType === 'PN' ? t('transfers.kwik.accountManagement.step3.phoneLabel') : t('transfers.kwik.accountManagement.step3.emailLabel'),
        content: formData.authMethodType === 'PN' ? customerInfo.customer.msisdn : customerInfo.customer.email
    }"/>
    <!-- *********************************************
	*               Confidentiality Block            *
	********************************************** -->
    <divider-generic
    icon="eye-lock"
    :title="t('transfers.kwik.accountManagement.step3.confidentialityTitle')"/>
    <text-block-generic
	:params="{
		label: t('transfers.kwik.accountManagement.step3.showNameLabel'),
		content: formData.privateName ? t('transfers.kwik.accountManagement.step3.yes') : t('transfers.kwik.accountManagement.step3.no')
	}"/>
</template>

<script setup>
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'
import DividerGeneric from '@/components/generic/dividers/Generic'

/* Assets & Helpers */
import { ACCOUNTS_NIB_IBAN } from '@/assets/constants/masks'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['scrollTo', 'updateFormData', 'fieldsAreInvalid'])

/** Props
@formData {Object} Object with info for our current form
@customerInfo {Object} Object with the customer info
*/

const props = defineProps({
	formData: Object,
    customerInfo: Object
})
</script>

<style lang="scss" scoped>
</style>
